// extracted by mini-css-extract-plugin
export var solidAchievementIcon = "SolidAchievementIcon-module__solidAchievementIcon___lD1ew";
export var xboxGreen = "#107C10";